import React, {useState, useEffect} from "react";
import api from "api";
import _ from "lodash";
const useMemberList = function(parameter, token){

    const [members, setMembers]         = useState(false);
    const [total, setTotal]             = useState(0);
    const [isLoading, setIsLoading]     = useState(true);

    useEffect(() => {

        setMembers(false);

        setIsLoading(true);

        Promise.all([
            api('/Role/Member', 'get', _.extend({}, parameter ), 'Bearer ' + token)
            ,api('/Role/Member', 'get', _.extend({}, parameter, {
                get_total : 1
            }), 'Bearer ' + token)
        ])

            .then((response) => {

                setIsLoading(false);

                setMembers(response[0].members);

                setTotal(response[1].members);

            })
            .catch((error) => {
                setIsLoading(false);
                
                setMembers([]);
            });
    }, [parameter]);

    return {
        members
        ,total
        ,isLoading
    }
}

export default useMemberList;